<template>
  <div class="body_page">
    <Header></Header>
    <div class="banner" ref="basicInformation">
      <div class="container">
        <div class="banner_content">
          <div class="banner_content_left">
            <h1 class="title-h2">
              <div>{{ $t('index.title') }}<br>{{ $t('index.title2') }} <span>{{ $t('index.title3') }}</span></div>
              <a href="http://p.cashavatar.lk/zGlUpK" download=""><img src="@/assets/google.png"></a>
            </h1>
            <div class="calculator">
              <div class="calculator__loader" v-show="showLoad">
                <div class="calculator__loader_inner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="calculator__box">
                <div class="calculator__box-wrapper">
                  <div class="calculator__box-value">
                    <div class="title">{{ $t('loan.LoanAmount') }}</div>
                    <div class="input_wrap">
                      <span>RS <span id="summa_min">{{$utils.spot(min2)}}</span></span>
                      <div class="input-amount"><span>RS </span>{{$utils.spot(progressVal)}}</div>
                      <span>RS <span id="summa_max">{{ $utils.spot(max) }}</span></span>
                    </div>
                  </div>
                  <div class="calculator__slider">
                    <div class="range" :style="'--step:100000; --min:'+min+'; --max:'+max+'; --value:'+progressVal+'; --text-value:'+progressVal+'; --tickEvery:4; --fill-color:linear-gradient(to right, #0089ff, var(--primaryColor));width:100%'">
                      <input type="range" :disabled="disabled"  id="slider-summa" class="slider" :min="min" :max="max" step="1000" :value="progressVal" @input="chageInput($event)">
                      <div class="bardrag" ></div>
                      <div class='range__progress'></div>
                    </div>
                  </div>
                  <div class="button-wrapper">
                    <div class="button-loan">
                      <button class="button"  @click="vipJump(MainVipProduct.action,MainVipProduct)">{{Mainbutton.words}}</button>
                    </div>
                  </div>
                  <div class="error">{{MainVipProduct.tips}}</div>
                  <div class="calculator__item" v-if="Mainbutton.action!='repay'">
                    <div class="calculator__item__box">
                      <span class="calculator__item__heading">{{ $t('loan.LoanAmount') }}</span>
                      <div class="calculator__item__text">
                            <span class="amount">
                                RS <span id="loan_amount">{{$utils.spot(progressVal)}}</span>
                            </span>
                      </div>
                    </div>
                    <div class="calculator__item__box">
                      <span class="calculator__item__heading">{{ $t('loan.loanPeriod') }}</span>
                      <div class="calculator__item__text">
                        <span id="payment_date">{{loanPeriod}} {{$t('loan.days')}}</span>
                      </div>
                    </div>
                    <div class="calculator__item__box">
                      <span class="calculator__item__heading">{{ $t('index.title4') }}</span>
                      <div class="calculator__item__text">
                            <span class="calculator__item__heading ">
                                <span>RS</span>
                               <span id="settlement_amount">{{$utils.spot(progressValRate)}}</span>
                            </span>
                      </div>
                    </div>
                  </div>
                  <div class="calculator__item" v-if="Mainbutton.action=='repay'">
                    <div class="calculator__item__box">
                      <span class="calculator__item__heading">{{ $t('loan.paymentAmount') }}</span>
                      <div class="calculator__item__text">
                            <span class="amount">
                                RS <span id="loan_amount">{{$utils.spot(MainVipProduct.repay_info.repay_amount)}}</span>
                            </span>
                      </div>
                    </div>
                    <div class="calculator__item__box">
                      <span class="calculator__item__heading">{{ $t('loan.repaymentDate') }}</span>
                      <div class="calculator__item__text">
                        <span id="payment_date">{{MainVipProduct.repay_info.repay_date}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="homeApply">
      <ul class="container">
        <b>Who is eligible to apply?</b>
        <li><img src="@/assets/hicon1.png"><span>20-60 years old</span></li>
        <li><img src="@/assets/hicon2.png"><span>Have an income</span></li>
        <li><img src="@/assets/hicon3.png"><span>Sri Lankan Residents</span></li>
      </ul>
    </div>
    <div class="container vipProductList" v-if="vipProductList.length>1">
      <div class="vipCatname">{{$t('table.vipBenefits')}}</div>
      <dl>
        <dd v-for="(item,index) in vipProductList" :key="index" v-if="index>0"  class="item" :class="item.action=='disable'? 'disable': ''">
            <div class="title"><h3>{{item.product_name}}</h3><span>{{item.level_info.vip_name}}</span></div>
            <ul>
              <li><p>{{item.product_amount}}<small>Rs</small></p><span>{{$t('loan.LoanAmount')}}</span></li>
              <li><p>{{item.product_period}}<small>{{ $t('loan.days') }}</small></p><span>{{$t('loan.loanPeriod')}}</span></li>
            </ul>
            <div class="appButton"><el-button @click="vipJump(item.action,item)">{{item.button.words}}</el-button></div>
            <div class="error">{{item.tips}}</div>
        </dd>
      </dl>
    </div>
    <section class="cards-block">
      <div class="title-h2">Get a loan in 15 minutes</div>
      <div class="container">
        <div class="cards-block-left">
          <div class="cards-block-left-title">
            <p>Giving everyone up to LKR 100,000 for any purpose</p>
            <span>Registration in 10 minutes</span>
          </div>
          <div class="cards-block-left-image"><img src="@/assets/card-left-image.png"> </div>
          <div class="reg-button"><button @click="onTouch">Get money</button></div>
        </div>
        <div class="cards-block-right">
          <div class="glide_slides">
              <div class="cards-slider-item glide_slide">
                <div class="cards-slider-item-title"><p>A simple loan</p></div>
                <div class="cards-slider-item-sub-title"><p>For service without additional conditions and commissions</p></div>
                <div class="cards-slider-item-bottom-info"><p><span>0%</span> new loan </p></div>
              </div>
              <div class="cards-slider-item glide_slide">
                <div class="cards-slider-item-title"><p>Minimum documents</p></div>
                <div class="cards-slider-item-sub-title"><p>Need only ID number</p></div>
                <div class="cards-slider-item-bottom-info"><img src="@/assets/hicon4.png"> </div>
              </div>
              <div class="cards-slider-item glide_slide">
                <div class="cards-slider-item-title"><p>Flexible loan</p></div>
                <div class="cards-slider-item-sub-title"><p>independent choice of the required amount</p></div>
                <div class="cards-slider-item-bottom-info">
                  <ul>
                    <li>
                      <p>for a repeat credit - from 5,000 <br> to 100,000 LKR</p>
                    </li>
                    <li>
                      <p>for a new loan - from 5,000 <br> to 50,000 LKR</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="cards-slider-item glide_slide">
                <div class="cards-slider-item-title"><p>Payday loan</p></div>
                <div class="cards-slider-item-sub-title"><p>We give credit for 7 to 30 days</p></div>
                <div class="cards-slider-item-bottom-info"><img src="@/assets/hicon5.png"> </div>
              </div>
              <div class="cards-slider-item glide_slide">
                <div class="cards-slider-item-title"><p>Reliable service</p></div>
                <div class="cards-slider-item-sub-title"><p>We guarantee the confidentiality and protection of your data</p></div>
                <div class="cards-slider-item-bottom-info"><img src="@/assets/hicon6.png"> </div>
              </div>
              <div class="cards-slider-item glide_slide">
                <div class="cards-slider-item-title"><p>Prolong the loan at any time</p></div>
                <div class="cards-slider-item-sub-title"><p>All operations on the loan in the personal account</p></div>
                <div class="cards-slider-item-bottom-info"><img src="@/assets/hicon7.png"> </div>
              </div>
          </div>
        </div>
      </div>
      <div style="text-align:center;"><a class="button" @click="onTouch">{{ $t('table.TakeLoan') }}</a></div>
    </section>
    <section class="registration">
      <div class="title-h2">Just 3 registration steps</div>
      <div class="container stages">
        <div class="item">
          <img src="@/assets/arrow-right.png">
          <div class="icon"><img src="@/assets/hicon8.png"> </div>
          <h3>Fill out the application form</h3>
          <p>Complete registration documents as instructed</p>
        </div>
        <div class="item">
          <img src="@/assets/arrow-right.png">
          <div class="icon"><img src="@/assets/hicon9.png"> </div>
          <h3>Wait for review results</h3>
          <p>Get the results of the review the same day after completing the application</p>
        </div>
        <div class="item">
          <div class="icon"><img src="@/assets/hicon10.png"> </div>
          <h3>Receive a loan</h3>
          <p>Get money into your bank account</p>
        </div>
      </div>
      <div style="text-align:center;"><a class="button" @click="onTouch">{{ $t('table.TakeLoan') }}</a></div>
    </section>
    <section class="customer">
      <div class="title-h2">Customer reviews</div>
      <div class="list">
        <ul>
          <li>
            <div class="title"><div class="name">Irshad Zahir</div><div class="date">05.02.2025</div></div>
            <div class="dis"> I’m impressed by the simplicity and speed of service. Within 20 minutes, I had the funds in my account.</div>
            <div class="rating">
              <div class="rating_stars">
                <div class="passive">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
                <div class="active">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
              </div>
              <div class="rating_number">5/5</div>
            </div>
          </li>
          <li>
            <div class="title"><div class="name">Lahiru</div><div class="date">03.02.2024</div></div>
            <div class="dis"> When I urgently need money before salary, I always turn to CashAvatar. No problem. Everything is fast and safe</div>
            <div class="rating">
              <div class="rating_stars">
                <div class="passive">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
                <div class="active">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
              </div>
              <div class="rating_number">5/5</div>
            </div>
          </li>
          <li>
            <div class="title"><div class="name">Kumarage Chamal</div><div class="date">04.15.2024</div></div>
            <div class="dis"> I am so happier you’re great service.  Every times I hot good response and the staff service call centre excellent tooo. Congratulations!!!</div>
            <div class="rating">
              <div class="rating_stars">
                <div class="passive">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
                <div class="active">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
              </div>
              <div class="rating_number">5/5</div>
            </div>
          </li>
          <li>
            <div class="title"><div class="name">Dilhani Renuka</div><div class="date">02.22.2024</div></div>
            <div class="dis"> Helped out when money was urgently needed. Returned from salary on time without overpayment. Thanks for the help</div>
            <div class="rating">
              <div class="rating_stars">
                <div class="passive">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
                <div class="active">
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                  <div class="star"></div>
                </div>
              </div>
              <div class="rating_number">5/5</div>
            </div>
          </li>
        </ul>
      </div>
      <div style="text-align:center;"><a class="button" @click="onTouch">{{ $t('table.TakeLoan') }}</a></div>
    </section>
    <Footer></Footer>
    <el-dialog :visible.sync="dialogVisible" :title="$t('table.Details')" @close="closeEdit">
      <el-form label-position="right" label-width="160px">
        <template v-for="(item,index) in loanDetial">
          <el-form-item :label="index">
            <el-input :value="item" disabled size="medium"  :placeholder="$t('tips.PleaseEnter')" />
          </el-form-item>
        </template>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Header from '../../components/homeHeader.vue'
import Footer from '../../components/footer.vue'
export default {
  components:{
    Header , Footer
  },
  data() {
    return {
      max: 5000,
      min: 1000,
      min2: 1000,
      activeColor: '#e9bf19',
      progressVal: 5000,
      progressValRate:1000,
      currentDate: this.getDay(6,1),
      isShow:false,
      vipProductList: [],
      disabled: false,
      info_status: {},
      dialogVisible: false,
      loanDetial:{},
      MainVipProduct:{},
      Mainbutton:{
        words: 'Apply Loan',
        action: 'apply'
      },
      loanPeriod: '',
      place: '',
      showLoad: false
    }
  },
  watch: {
  },
  created(){
    this.getIndex()
    if(this.$route.query.place){
      this.place = this.$route.query.place
      localStorage.setItem('place',this.$route.query.place)
    }
  },
  methods: {
    getErweima(){
      this.isShow = !this.isShow
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${day}.${month}.${year}`;
    },
    getDay(day,month) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + month);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth  + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    chageInput(e){
      this.progressVal = e.target.value
      this.progressValRate = parseInt(this.progressVal) + parseInt(this.progressVal*0.03)

    },
    getIndex(){
      let that = this
      that.showLoad = true
      that.$api.post('api/product',null,r =>{
        that.vipProductList = r.data.product
        that.info_status = r.data.info_status
        that.MainVipProduct = r.data.product[0]
        that.Mainbutton = that.MainVipProduct.button
        that.MainVipProduct.product_amount = that.MainVipProduct.product_amount2
        that.max = that.MainVipProduct.product_amount
        that.progressVal = that.MainVipProduct.product_amount2
        that.progressValRate = parseInt(that.progressVal) + parseInt(this.progressVal*0.38)
        that.loanPeriod = that.MainVipProduct.product_period
        if(localStorage.getItem('token')){
          that.disabled = true
          that.min2 = that.MainVipProduct.product_amount
        }else{
          that.disabled = false
        }
        that.showLoad = false
      })
    },
    vipJump(type,item){
      let that = this
      if(localStorage.getItem('token')){
        if(type=='apply'){
          if(that.info_status.status){
            that.$router.push({path:'/loanProduct',query:{product_name:item.product_code}});
          }else{
            that.$router.push({path:'/step1',query:{product_name:item.product_code}});
          }
        }else if(type=='repay'){
          that.$router.push({path:'/repayment',query:{order_no:item.order_no}});
        }else if(type=='disable'){
          that.$utils.alertText(that.$t('tips.disableTip'));
        }else if(type=='back_pic'){
          that.$router.push({path:'/photoRollback',query:{data:item.button.back_picture,order_no:item.order_no}});
        }else if(type=='back_bank'){
          that.$router.push({path:'/bankRollback',query:{order_no:item.order_no}});
        }else{
          let data = {
            'order_no': item.order_no
          }
          that.$api.post('api/loan_detail',data,r =>{
            that.loanDetial = r.data
            that.dialogVisible = true
          })
        }
      }else {
        this.$router.push({path:'/login'});
      }
    },
    closeEdit(){
      this.dialogVisible = false
    },
    onTouch(){
      this.$refs.basicInformation.scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"  	// 上边框与视窗顶部平齐。默认值
      });
    }

  }
}
</script>
